// Vue Query setup for the app and a shared QueryClient instance
// We expose a singleton queryClient to be reused outside components (e.g., in services)
// so we can benefit from TanStack Query's caching via queryClient.fetchQuery/ensureQueryData.

import { QueryClient } from '@tanstack/vue-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Adjust as needed. We start conservatively to avoid excessive refetching.
      staleTime: 60 * 1000, // 1 minute
      gcTime: 5 * 60 * 1000, // 5 minutes (v5 uses gcTime instead of cacheTime)
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
})
